export default class PropertyAPIs {
  constructor(_api) {
    this.api = _api;
  }

  getSuggestions = (query) => {
    return this.api.get(`/v1/suggestions?query=${query}`);
  };

  getProperties = ({ target, filter, options }) => {
    return this.api.post("/v1/search", { target, filter, options });
  };

  getPropertyDetails = (propertyId) => {
    return this.api.get(`/v1/property?propertyId=${propertyId}`);
  };

  getNearbyInsights = (propertyId) => {
    return this.api.post(`/v1/comparables`, { target: { propertyId } });
  };
}
